module.exports = __webpack_public_path__ + "img/telegram.560892ea.svg";